<script setup>
import { computed } from "vue";
import { LogIn } from "lucide-vue-next";
import { APP_BASE } from "@/shared/config/constants";
import { useAuthStore } from "@/stores/auth";

const props = defineProps({
  redirect: { type: String, default: APP_BASE },
});

const auth = useAuthStore();
const loginUrl = computed(() => auth.loginUrl(props.redirect));
</script>

<template>
  <section class="login-panel">
    <div class="login-copy">
      <h2>微信登录后查看排行榜</h2>
      <p>登录后可以查看社区日榜，并批准 mac app 设备配对。</p>
    </div>
    <a class="btn-black" :href="loginUrl">
      <LogIn :size="16" />
      微信登录
    </a>
  </section>
</template>
